<template>
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="group_resource_permission"
    role="dialog"
    data-backdrop="static"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
            v-if="modalStatus === 'single'"
          >
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            {{ modalStatus === "single" ? "设置共享" : "批量设置权限" }}
          </h4>
        </div>
        <!-- 设置权限-single -->
        <div
          :class="[{ single: modalStatus === 'single' }, 'modal-body']"
          v-show="modalStatus === 'single'"
        >
          <span class="fz-12">
            <svg aria-hidden="true" class="icon">
              <use :xlink:href="'#icon-folder'" />
            </svg>
            &nbsp;
            <span :title="folder.name">{{ folder.name }}</span>
          </span>
          <div class="form-group user-search-from">
            <div class="share-user" v-clickoutside="closeSearchList">
              <input
                ref="userSearch"
                type="text"
                class="share-input"
                v-model.trim="searchUserName"
                placeholder="输入姓名，进行模糊搜索"
                @focus="focusEvent"
              />
              <div
                class="share-search user-search-to"
                v-show="searchUsers.length && showSearchList"
              >
                <ul>
                  <li
                    v-for="(user, index) in searchUsers"
                    :key="index"
                    @click="addUser(user)"
                    v-show="user.show"
                  >
                    <a>
                      <img
                        :src="user.avatar"
                        style="width: 30px; height: 30px; border-radius: 15px"
                      />
                      {{ user.name }}（{{ user.email }}）
                      <span
                        :class="[
                          user.exist
                            ? 'iconfont icon-status-succ'
                            : 'glyphicon glyphicon-plus-sign',
                        ]"
                        aria-hidden="true"
                      ></span>
                    </a>
                  </li>
                </ul>
              </div>
              <div
                class="share-search user-search-to"
                v-show="noSearchUsers && showSearchList"
              >
                <ul>
                  <li>
                    <a>未搜索到任何用户</a>
                  </li>
                </ul>
              </div>
            </div>
            <span class="help-block" v-show="errors.has('user')">{{
              errors.first("user")
            }}</span>
          </div>
          <div class="form-group">
            <div class="group-list-wrap clearfix">
              <div class="group-list">
                <div class="permission-user">共享人</div>
                <div class="permission-list">
                  权限
                  <i
                    class="iconfont icon-group-question"
                    style="cursor: pointer"
                    @click="toggleRoleDesc"
                  ></i>
                  <span
                    style="cursor: pointer; color: #006adf"
                    @click="toggleRoleDesc"
                  >
                    查看权限说明</span
                  >
                </div>
                <div class="delete"></div>
              </div>
              <div
                class="group-list"
                v-for="(user, index) in member_list"
                :key="index"
              >
                <div
                  class="permission-user"
                  :title="user.name + '（' + user.email + '）'"
                >
                  <img :src="user.avatar" />
                  {{ user.name }}（{{ user.email }}）
                </div>
                <div class="permission-list">
                  <select v-model="user.role_type">
                    <option
                      :value="roleType.value"
                      v-for="(roleType, index) in roleTypes"
                      :key="index"
                      :title="getRoleDesc(roleType.value)"
                    >
                      {{ roleType.label }}
                    </option>
                  </select>
                </div>
                <div class="delete">
                  <i
                    class="iconfont icon-close close"
                    @click="removeUser(user)"
                  ></i>
                </div>
              </div>
            </div>

            <div
              class="group-list"
              style="margin-bottom: 20px; border: none; font-weight: bold"
            >
              <div class="permission-user" style="width: unset">
                新入群成员当前目录的权限：
              </div>
              <div class="permission-list">
                <select v-model="newUserRoleType">
                  <optgroup label="权限">
                    <option
                      :value="roleType.value"
                      v-for="(roleType, index) in roleTypes"
                      :key="index"
                      :title="getRoleDesc(roleType.value)"
                    >
                      {{ roleType.label }}
                    </option>
                  </optgroup>
                  <optgroup label="无权限">
                    <option value="0">无权限</option>
                  </optgroup>
                </select>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <!-- 设置权限-batch -->
        <div
          :class="[{ batch: modalStatus === 'batch' }, 'modal-body']"
          v-show="modalStatus === 'batch'"
        >
          <div class="form-group">
            <div class="group-list-wrap clearfix">
              <div class="group-list">
                <div class="permission-user">
                  权限名称
                  <i
                    class="iconfont icon-group-question"
                    style="cursor: pointer"
                    @click="toggleRoleDesc"
                  ></i>
                  <span
                    style="cursor: pointer; color: #006adf"
                    @click="toggleRoleDesc"
                  >
                    查看权限说明</span
                  >
                </div>
                <div class="permission-list">用户列表</div>
              </div>
              <div
                class="group-list"
                v-for="(item, index) in permissions"
                :key="index"
              >
                <div class="permission-user" :title="item.name">
                  {{ item.name }}
                </div>
                <div class="permission-list">
                  <span
                    class="set-user-role"
                    @click="handleSetUserForRole(item.role_id)"
                    >配置用户</span
                  >（{{ item.users.length }}）
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 设置权限-batch-edit -->
        <div
          :class="[{ batch: modalStatus === 'batch-edit' }, 'modal-body']"
          v-show="modalStatus === 'batch-edit'"
        >
          <div class="form-group text-right">
            权限：{{ getRole(editingPermission) }}
          </div>
          <div class="form-group">
            <div id="treeview-role-user" class="treeview"></div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            v-if="right__group_resource_role_batch_grant_to_members && modalStatus === 'single'"
            class="btn btn-default"
            type="button"
            @click.stop="getGroupMemberRightsAndToggleModalStatus"
          >
            批量设置
          </button>
          <button
            class="btn btn-default"
            data-dismiss="modal"
            type="button"
            v-if="modalStatus === 'single'"
          >
            取消
          </button>
          <button
            class="btn btn-default"
            type="button"
            @click.stop="close"
            v-if="modalStatus === 'batch'"
          >
            关闭
          </button>
          <!-- <button
            class="btn btn-default"
            type="button"
            @click.stop="getSingleListAndToggleModalStatus"
            v-if="modalStatus === 'batch'"
          >
            返回
          </button> -->
          <button
            class="btn btn-default"
            type="button"
            @click.stop="toggleModalStatus('batch')"
            v-if="modalStatus === 'batch-edit'"
          >
            返回
          </button>
          <button
            class="btn btn-primary"
            type="button"
            v-if="modalStatus === 'batch-edit'"
            @click="batchSave"
          >
            保存1
          </button>
          <button
            class="btn btn-primary"
            type="button"
            @click="setGroupResourceRoleGrantToMembers"
            v-if="modalStatus === 'single'"
          >
            提交
          </button>
        </div>
      </div>
      <div class="role-desc-wraper" v-show="showRoleDesc">
        <div class="role-desc-close" @click="toggleRoleDesc" title="关闭">
          <i class="iconfont icon-close close"></i>
        </div>
        <p>权限对应的功能：</p>
        <div class="role-desc-body">
          <table class="role-desc-table" border="1" cellpadding="10">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th>拥有者</th>
                <th>上传下载</th>
                <th>仅下载</th>
                <th>仅上传</th>
                <th>仅预览</th>
                <th>发布（需后台先开启）</th>
                <th>管理者</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="10">文件</td>
                <td>在线查看文件</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√（仅自己）</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>创建/上传文件</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>下载文件</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>编辑文件</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√（仅自己）</td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>删除文件</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>重命名文件</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√（仅自己）</td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>保存到网盘</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>设置标签</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>发布文件</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td>历史版本</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td>√（仅自己）</td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td rowspan="7">文件夹</td>
                <td>查看文件夹</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>创建文件夹</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>重命名文件夹</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>删除文件夹</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>保存到网盘</td>
                <td>√</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>设置标签</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td>√</td>
              </tr>
              <tr>
                <td>发布文件夹</td>
                <td>√</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td>权限</td>
                <td>修改共享文件夹权限</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
              </tr>
              <tr>
                <td rowspan="2">发布</td>
                <td>新建</td>
                <td>√</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>√</td>
                <td></td>
              </tr>
              <tr>
                <td>管理</td>
                <td>√（所有）</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>√（仅自己）</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRole, getRoleDesc } from "@/utils/permission";
import {
  getGroupMembers,
  getGroupResourceRoleRoleTypes,
  getGroupResourceRoleFolderRoleList,
  setGroupResourceRoleGrantToMembers,
  setBatchGroupResourceRoleGrantToMembers,
  getGroupMemberRights,
  setGroupNewUserRole,
} from "@/api/group/group";
import debounce from "lodash.debounce";
export default {
  name: "GroupResourcePermission",
  props: {
    folder: {
      type: Object,
      default: () => {
        return { number: "" };
      },
    },
    group_number: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      /**
       * 弹窗状态：
       * single —— 单个设置用户权限
       * batch —— 批量设置用户权限-列表页
       * batch-edit —— 批量设置用户权限-编辑页
       */
      modalStatus: "single",
      editingPermission: "",
      permissions: [
        {
          role_id: 1,
          name: "拥有者",
          users: [],
        },
        {
          role_id: 2,
          name: "上传下载",
          users: [],
        },
        {
          role_id: 3,
          name: "仅下载",
          users: [],
        },
        {
          role_id: 4,
          name: "仅上传",
          users: [],
        },
        {
          role_id: 5,
          name: "仅预览",
          users: [],
        },
        {
          role_id: 6,
          name: "发布",
          users: [],
        },
        {
          role_id: 7,
          name: "管理者",
          users: [],
        },
      ],
      member_list: [], // 设置了群权限的用户
      memberTree: [],
      selectedGroupMembers: [], // 批量设置-已选择的用户
      noSearchUsers: false,
      showSearchList: false,
      searchUserName: "",
      searchUsers: [],
      roleTypes: [],
      showRoleDesc: false,
      newUserRoleType: 2,
    };
  },
  computed: {
    right__group_resource_role_batch_grant_to_members () {
      return this.$store.getters.right__group_resource_role_batch_grant_to_members
    },
  },
  watch: {
    searchUserName: {
      handler: function (newValue) {
        if (newValue.trim()) {
          this.debouncedUserSearch();
        } else {
          this.noSearchUsers = false;
          if (this.searchUsers.length) {
            this.searchUsers = this.searchUsers.map((item) => {
              item.show = true;
              // const user = this.member_list.find((item2) => {
              //   return item2.user_id === item.user_id;
              // });
              // if (user) {
              //   item.exist = true;
              // }
              return item;
            });
          }
        }
      },
    },
  },
  methods: {
    batchSave() {
      // 批量保存
      const form = {
        group_number: this.group_number,
        folder_id: this.folder.number,
        role_type: this.editingPermission,
        member_list: this.selectedGroupMembers.map((item) => {
          return {
            user_id: item,
          };
        }),
      };
      setBatchGroupResourceRoleGrantToMembers(form)
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.getGroupMemberRightsAndToggleModalStatus();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getRole(role_id) {
      return getRole(role_id);
    },
    async handleSetUserForRole(role_id) {
      this.selectedGroupMembers = [];
      $("#treeview-role-user").html("");
      this.editingPermission = role_id;
      this.toggleModalStatus("batch-edit");
      await this.getGroupMemberRights();
      let users = this.permissions.find((item) => {
        return item.role_id === role_id;
      }).users;
      this.selectedGroupMembers = users.map((item) => item.user_id);
      // 获取群用户，显示到treeview
      getGroupMembers({
        group_number: this.group_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.memberTree = res.entity
              .filter((item) => {
                return item.group_member_identity != "owner";
              })
              .map((item) => {
                return {
                  text: `<img class="tree-avatar" src="${item.group_member_avatar}"> ${item.group_member_name}（${item.group_member_email}）`,
                  number: item.group_member_number,
                  state: {
                    selected: this.selectedGroupMembers.length
                      ? this.selectedGroupMembers.indexOf(
                          item.group_member_number
                        ) > -1
                      : false,
                  },
                };
              });
            $("#treeview-role-user").treeview({
              multiSelect: true,
              expandIcon: "ti ti-angle-right",
              collapseIcon: "ti ti-angle-down",
              nodeIcon: "glyphicon glyphicon-unchecked",
              showTags: true,
              selectedIcon: "glyphicon glyphicon-check",
              onNodeSelected: (event, data) => {
                this.selectedGroupMembers.push(data.number);
              },
              onNodeUnselected: (event, data) => {
                const index = this.selectedGroupMembers.indexOf(data.number);
                this.selectedGroupMembers.splice(index, 1);
              },
              data: this.memberTree,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    close() {
      this.toggleModalStatus("single");
      $("#group_resource_permission").modal("hide");
    },
    getSingleListAndToggleModalStatus() {
      this.toggleModalStatus("single");
      this.getGroupResourceRoleFolderRoleList();
    },
    getGroupMemberRightsAndToggleModalStatus() {
      this.toggleModalStatus("batch");
      $("button").blur();
      this.getGroupMemberRights();
    },
    async getGroupMemberRights() {
      const param = {
        group_number: this.group_number,
        folder_id: this.folder.number,
      };
      // 先清除角色用户
      this.permissions.map((item) => {
        item.users = [];
      });
      await getGroupMemberRights(param)
        .then((res) => {
          if (res.status_code === 200) {
            res.entity.map((item) => {
              this.permissions.map((item2) => {
                if (item.role_id === item2.role_id) {
                  item2.users.push(item);
                }
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    toggleModalStatus(status) {
      this.modalStatus = status;
    },
    toggleRoleDesc() {
      this.showRoleDesc = !this.showRoleDesc;
    },
    getRoleDesc(param) {
      return getRoleDesc(param);
    },
    closeSearchList() {
      this.showSearchList = false;
      // this.searchUserName = "";
    },
    async focusEvent() {
      this.showSearchList = true;
      // if (!this.searchUsers.length) {
      //   await this.getGroupMembers();
      // }
      this.userSearch();
    },
    userSearch() {
      if (this.searchUsers.length) {
        this.showSearchList = true;
        this.searchUsers = this.searchUsers.map((item) => {
          if (
            item.name.indexOf(this.searchUserName) > -1 ||
            item.email.indexOf(this.searchUserName) > -1
          ) {
            item.show = true;
          } else {
            item.show = false;
          }
          const user = this.member_list.find((item2) => {
            return item2.user_id === item.user_id;
          });
          if (user) {
            item.exist = true;
          }
          return item;
        });
      } else {
        this.noSearchUsers = true;
      }
    },
    addUser(user) {
      if (user.exist) {
        this.removeUser(user);
      } else {
        user.exist = true;
        this.member_list.push({
          avatar: user.avatar,
          user_id: user.user_id,
          name: user.name,
          email: user.email,
          role_type: 2,
        });
      }
    },
    removeUser(user) {
      const index = this.member_list.findIndex((item) => {
        return item.user_id === user.user_id;
      });
      if (index > -1) {
        const user1 = this.searchUsers.find((item) => {
          return item.user_id === user.user_id;
        });
        user1.exist = false;
        this.member_list.splice(index, 1);
      }
    },
    getGroupMembers() {
      return getGroupMembers({ group_number: this.group_number })
        .then((res) => {
          if (res.status_code === 200) {
            this.searchUsers = res.entity
              .filter((item) => item.group_member_identity != "owner")
              .map((item) => {
                return {
                  exist: false,
                  show: true,
                  avatar: item.group_member_avatar,
                  name: item.group_member_name,
                  email: item.group_member_email,
                  user_id: item.group_member_number,
                };
              });
            return this.searchUsers;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getGroupResourceRoleRoleTypes() {
      if (this.roleTypes.length) {
        return false;
      }
      getGroupResourceRoleRoleTypes()
        .then((res) => {
          if (res.status_code === 200) {
            this.roleTypes = res.entity;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    async getGroupResourceRoleFolderRoleList() {
      if (this.searchUsers.length) {
        this.searchUsers = this.searchUsers.map((item) => {
          item.exist = false;
          return item;
        });
      } else {
        await this.getGroupMembers();
      }
      getGroupResourceRoleFolderRoleList({
        group_number: this.group_number,
        folder_id: this.folder.number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.newUserRoleType = res.entity.new_member_role;
            this.member_list = res.entity.member_role_list
              .filter((item) => {
                if (this.searchUsers.length) {
                  let user = this.searchUsers.findIndex(
                    (item1) => item1.user_id === item.user_id
                  );
                  if (user > -1) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              })
              .map((item) => {
                let user = {};
                this.searchUsers = this.searchUsers.map((item1) => {
                  if (item1.user_id === item.user_id) {
                    item1.exist = true;
                    user = item1;
                  }
                  return item1;
                });
                return {
                  user_id: item.user_id,
                  role_type: item.role_type,
                  avatar: user.avatar,
                  name: user.name,
                  email: user.email,
                };
              });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    async setGroupResourceRoleGrantToMembers() {
      const form = {
        group_number: this.group_number,
        folder_id: this.folder.number,
        member_list: this.member_list.map((item) => {
          return {
            user_id: item.user_id,
            role_type: item.role_type,
          };
        }),
      };
      await this.setGroupNewUserRole();
      await setGroupResourceRoleGrantToMembers(form)
        .then((res) => {
          if (res.status_code === 200) {
            $("#group_resource_permission").modal("hide");
            // 更新权限
            this.$store.dispatch("getGroupRolePermissions", this.group_number);
            this.$message({
              type: "success",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    async setGroupNewUserRole() {
      let param = {
        group_number: this.group_number,
        folder_id: this.folder.number,
        role_type: this.newUserRoleType,
      };
      setGroupNewUserRole(param)
        .then((res) => {
          if (res.status_code === 200) {
            // this.$message({
            //   type: "success",
            //   message: res.message,
            // });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    $("#group_resource_permission").on("shown.bs.modal", () => {
      this.modalStatus = "single";
      this.getGroupResourceRoleRoleTypes();
      this.getGroupResourceRoleFolderRoleList();
      // this.setGroupResourceRoleGrantToMembers();
      this.debouncedUserSearch = debounce(this.userSearch, 500);
    });
    $("#group_resource_permission").on("hidden.bs.modal", () => {
      this.member_list = [];
    });
  },
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
};
</script>

<style scoped>
.user-search-from {
  position: relative;
}
.share-search {
  top: 35px;
}
.group-list .permission-user {
  /* background: #f1f1f1; */
  padding-left: 10px;
  float: left;
  width: calc(100% - 140px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.group-list .permission-user img {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin: -2px 0 0 4px;
}
.group-list .permission-list {
  padding-left: 10px;
  float: left;
  width: 80px;
  white-space: nowrap;
}
.group-list .delete {
  padding-left: 10px;
  float: right;
  width: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.group-list .delete i {
  line-height: 30px;
  font-size: 12px;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
}
.permission-list select {
  border: none;
}
.permission-list select:focus-visible {
  outline: none;
}
.fz-12 {
  font-size: 12px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-bottom: 10px;
  text-align: right;
}
.fz-12 svg {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.role-desc-wraper {
  position: absolute;
  top: -80px;
  left: -140px;
  right: -140px;
  /* bottom: -90px; */
  z-index: 9999;
  background-color: #fff;
  padding: 30px 30px 20px 30px;
  box-shadow: 0 3px 9px rgb(0 0 0 / 20%);
}
@media (max-width: 768px) {
  .role-desc-wraper {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .role-desc-body {
    width: 100%;
    height: 100%;
    overflow: scroll;
  }
  .role-desc-table {
    width: 720px !important;
  }
}
.role-desc-close {
  position: absolute;
  right: 20px;
  top: 20px;
}
.role-desc-table {
  width: 100%;
  margin: 10px 0;
}
.role-desc-table th,
.role-desc-table td {
  padding: 3px;
  text-align: center;
}
.bold-font {
  font-weight: bold;
}
.batch .group-list {
  padding: 8px 10px;
}
.batch .group-list-wrap {
  height: 380px;
}
.batch .group-list .permission-list {
  float: right;
  width: 120px;
}
.batch .set-user-role:hover {
  cursor: pointer;
}
.icon-status-succ {
  color: #00c15c;
}
</style>